import { FieldArray, useFormikContext } from "formik";
import Button from "components/form/Button";
import Card from "components/Layout/Card";
import React from "react";
import { icons } from "utils/constants";
import ResearchInformation from "./ResearchInformation";
import { useSelector } from "react-redux";

const RelevantKeynoteSpeakers = ({ onBack, onNext, btnLoading }) => {
  const { values, handleChange } = useFormikContext();
  const reduxData = useSelector((state) => state.aiAbstractSubmission);
  const { aiAbstractData } = reduxData || {};
  return (
    <>
      <ResearchInformation />

      <Card className="cp-20 cmt-20">
        {aiAbstractData?.speaker_details?.length > 0 &&
          <>
            <div className="text-16-500 color-1717 cmb-20">
              Relevant Keynote Speakers
            </div>
            <div className="border-bottom cmb-20 color-d1d1"></div>

            <FieldArray
              name="relevant_keynote_speakers"
              render={(arrayHelpers) => (
                <div className="row g-3">
                  {aiAbstractData?.speaker_details?.map((speaker, index) => {
                    const labelClasses =
                      speaker?.high_preference
                        ? "bg-fff2 text-14-500 color-5110 "
                        : " bg-eff3 text-14-500 color-new-car";

                    const rowBg = speaker?.high_preference ? "bg-white" : " bg-F9F9F9";

                    return (
                      <div
                        className={`col-12 ${rowBg} py-2 rounded-2`}
                        key={index}
                      >
                        <div className="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap">
                          {/* Left Section */}
                          <div className="col-12 col-lg-5 col-md-6 d-flex align-items-center gap-3 flex-grow-1">
                            <div className="flex-shrink-0">
                              <img
                                src={speaker.photo || icons.SpeakersIcon}
                                alt="Speaker"
                                className="img-fluid rounded-circle"
                                style={{ width: "40px", height: "40px" }}
                              />
                            </div>
                            <div className="min-w-0">
                              <div className="text-14-500 color-new-car text-wrap">
                                {speaker.name}
                              </div>
                              <div className="text-12-400 color-6866 text-wrap">
                                {speaker.speaker_type}
                              </div>
                            </div>
                          </div>

                          {/* Right Section */}
                          {(speaker?.high_preference || speaker?.recommended) &&
                            <div className="col-12 col-lg-4 col-md-4 d-flex align-items-center gap-3 flex-shrink-0 mt-2 mt-md-0">
                              <span
                                className={`${labelClasses} br-2 px-3 py-1 text-center text-nowrap d-inline-flex align-items-center justify-content-center`}
                                style={{ minHeight: "38px", minWidth: "184px" }}
                              >
                                {speaker?.high_preference ? "Highly Relevant" : "Recommended"}
                              </span>
                            </div>}
                          {/* 
                        <div
                          className="border rounded-2 bg-F3F4F8 d-flex align-items-center justify-content-center pointer"
                          style={{ width: "51px", height: "38px" }}
                          onClick={() => arrayHelpers.remove(index)}
                        >
                          <i className="bi bi-trash" style={{ fontSize: "18px" }}></i>
                        </div>
                      </div> */}

                          {/* <div className="col-12 col-lg-3 col-md-3"></div> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
              }
            />
          </>}

        {/* Navigation */}
        <div className="d-flex gap-3 cmt-20">
          {onBack && (
            <Button
              id="btn_keynote_speakers_back"
              text="Back"
              btnStyle="light-outline"
              className="cps-40 cpe-40 h-38"
              onClick={onBack}
              disabled={btnLoading}
            />
          )}
          <Button
            id="btn_keynote_speakers_submit"
            text="Save & Proceed"
            btnStyle="primary-dark"
            className="cps-40 cpe-40 h-38"
            onClick={onNext}
            disabled={btnLoading}
            btnLoading={btnLoading}
          />
        </div>
      </Card>
    </>
  );
};

export default RelevantKeynoteSpeakers;
